module.exports = __webpack_public_path__ + "static/media/rectangle-10@3x.2e9e8230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/rectangle-10@3x.png
// module id = 75
// module chunks = 19